import React, { type ReactNode } from 'react';

import CollapseDetail from '@/common/components/collapse';
import Text from '@/common/components/text';

import BasketIcon from '~/public/assets/images/svg/basket-icon.svg';
import CoinIcon from '~/public/assets/images/svg/coin-icon.svg';
import SecurePayment from '~/public/assets/images/svg/secure-payment-icon-2.svg';

interface DetailType {
  icon: ReactNode;
  title: string;
  description: string | ReactNode;
}

const detailParameter: DetailType[] = [
  {
    icon: <SecurePayment />,
    title: 'پرداخت امن',
    description: (
      <>
        در صورت عدم تایید سفارش توسط فروشنده <br /> مبلغ به حساب‌تون برمی‌گرده.
      </>
    ),
  },
  {
    icon: <CoinIcon />,
    title: 'درگاه پرداخت آنلاین',
    description: (
      <>
        همه سفارش‌ها از طریق درگاه پرداخت بانکی <br /> انجام میشه.
      </>
    ),
  },
  {
    icon: <BasketIcon />,
    title: 'پیگیری سفارش',
    description: (
      <>
        بعد از خرید، لینک پیگیری وضعیت سفارش <br /> براتون پیامک می‌شه.
      </>
    ),
  },
];

const details = (
  <div className="w-full lg:grid lg:grid-cols-3 lg:items-start lg:gap-4 lg:rounded-[20px] lg:bg-white lg:px-12 lg:py-6">
    {detailParameter.map((item: DetailType, index: number) => {
      return (
        <div
          key={index}
          className="flex h-[82px] items-center gap-2 lg:!h-full lg:!w-auto  lg:max-w-[304px] lg:flex-col lg:justify-start"
        >
          <div className=" flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-silver-200">
            {item.icon}
          </div>
          <div>
            <h3 className="mb-[8px] mt-4 text-sm font-medium text-black-400 lg:text-center lg:font-semibold lg:text-[#174170]">
              {item.title}
            </h3>
            <Text className="text-xs font-normal text-silver-500 lg:text-center">
              {item.description}
            </Text>
          </div>
        </div>
      );
    })}
  </div>
);

function OtherDetail() {
  return (
    <div className="lg:mx-auto lg:w-[1040px]">
      <CollapseDetail
        className="lg:!hidden"
        panelClassName="text-xs font-medium text-secondary-300 "
        panelHeader="سایر توضیحات"
      >
        {details}
      </CollapseDetail>
      <div className="w-ful my-[48px] hidden lg:!block">{details}</div>
    </div>
  );
}

export default OtherDetail;
